import ClaimSummary from '@app/features/Claim/components/ClaimSummary';
import { ClaimSummaryProps } from '@app/features/Claim/types';
import ReactRootProviders from '@client/src/global/context/ReactRootProviders';
import angular from 'angular';
import React from 'react';
import { react2angular } from 'react2angular';

function WrappedClaimSummary(props: ClaimSummaryProps) {
  return (
    <ReactRootProviders>
      <ClaimSummary {...props} />
    </ReactRootProviders>
  );
}

export const AngularClaimSummary = react2angular(WrappedClaimSummary, ['shipmentId'], []);

const MODULE_NAME = 'app.manage-shipments.shipment-information.claim-summary';

angular.module(MODULE_NAME, []).component('esClaimSummary', AngularClaimSummary);

export default MODULE_NAME;
